/** enum with all available workspace types */
export var WorkspaceType;
(function (WorkspaceType) {
    WorkspaceType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    WorkspaceType["STUDIO"] = "STUDIO";
    /** deprecated */
    WorkspaceType["PARTNERS"] = "PARTNERS";
    WorkspaceType["DIY"] = "DIY";
    WorkspaceType["ENTERPRISE"] = "ENTERPRISE";
    WorkspaceType["CHANNELS"] = "CHANNELS";
})(WorkspaceType || (WorkspaceType = {}));
/** enum with all available statuses of account */
export var AccountStatus;
(function (AccountStatus) {
    AccountStatus["ACTIVE"] = "ACTIVE";
    AccountStatus["BLOCKED"] = "BLOCKED";
    AccountStatus["DELETED"] = "DELETED";
})(AccountStatus || (AccountStatus = {}));
/** co branding flag options for account */
export var CoBranding;
(function (CoBranding) {
    CoBranding["None"] = "None";
    CoBranding["CoBranded"] = "CoBranded";
    CoBranding["CoBranded_Customer_New"] = "CoBranded_Customer_New";
    CoBranding["CoBranded_Customer_Existing"] = "CoBranded_Customer_Existing";
})(CoBranding || (CoBranding = {}));
//# sourceMappingURL=types.impl.js.map